import { curry } from 'ramda'
import { VEHICLE_TYPE_CHEC_PLUS } from 'utils/constants'

const hardwiredComponentType = {
  name: 'hardwiredComponentType',
  rule: curry((state, component, location) => {
    const { locations } = state
    const componentLocation = locations[component.location]
    if (!componentLocation) return true
    return componentLocation.panel === location?.panel
  }),
}

const hardwiredSwitchType = {
  name: 'hardwiredSwitchType',
  rule: hardwiredComponentType.rule,
}

const smartSwitchType = {
  name: 'smartSwitchType',
  rule: curry((state, component, location) => {
    if (state.vehicleType === VEHICLE_TYPE_CHEC_PLUS) return true
    return hardwiredComponentType.rule(state)(component, location)
  }),
}

export const rules = {
  'hardwired-component': [hardwiredComponentType],
  'hardwired-switch': [hardwiredSwitchType],
  'smart-switch': [smartSwitchType],
}
